var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.948,
    viewBox: "0 0 80.945 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "#dea63b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.138,20.866h-4.5V20.1a3.115,3.115,0,0,1,1.155-2.5l1.756-1.854a5.133,5.133,0,0,0,1.734-4.117V10.034c0-2.335-1.132-3.443-3.587-3.443-2.406,0-3.634,1.276-3.634,3.564v1.972h2.5V10.081c0-.986.482-1.275,1.06-1.275.528,0,.986.217.986,1.228v1.348A3.239,3.239,0,0,1,11.6,14.2l-1.541,1.637c-1.492,1.59-2.046,2.649-2.046,4.261V23.1h7.126Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.287,68.782V69.92a.2.2,0,0,0,0,.026.219.219,0,0,0,0,.027.535.535,0,0,0,.525.511l.01,0,.014,0H46.188l.011,0,.012,0a.537.537,0,0,0,.527-.534l0,0,0,0V68.654C54.254,66.19,59.885,60.1,61.123,52.673l.008-.044a.475.475,0,0,0,.007-.074.539.539,0,0,0-.54-.54H18.043a.54.54,0,0,0-.542.54l.028.242c1.3,7.495,7.087,13.621,14.758,15.985",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.725,33.852c-.175.25-4.287,6.169.092,10.955,2.008,2.2,1.834,4.135,1.26,5.444h2.809c.569-1.933.334-4.357-1.946-6.848-3.226-3.527.041-8.294.09-8.368a1.053,1.053,0,0,0-.456-1.572,1.493,1.493,0,0,0-1.849.389",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.612,50.251h2.81c.568-1.933.332-4.357-1.948-6.849-3.228-3.527.038-8.292.089-8.37a1.051,1.051,0,0,0-.457-1.569,1.489,1.489,0,0,0-1.847.389c-.176.248-4.291,6.168.092,10.955,2.008,2.2,1.833,4.136,1.261,5.444",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.791,33.852c-.178.25-4.289,6.169.09,10.955,2.009,2.2,1.836,4.136,1.264,5.444h2.808c.568-1.932.334-4.356-1.949-6.848-3.227-3.527.041-8.294.092-8.37a1.052,1.052,0,0,0-.459-1.57,1.485,1.485,0,0,0-1.846.389",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.207,12.493h1.688V13.4H23.046v-.907l1.746-4.8h-1.57V6.786h2.741v.908Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.646,6.786H29.3v.907H27.758V9.586h1.1v.9h-1.1v2.01H29.3V13.4H26.646Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,7.693V9.751h.371a.481.481,0,0,0,.546-.546V8.23c0-.361-.165-.537-.546-.537Zm0,2.673V13.4H29.993V6.786h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3H32.149Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,11.869V8.318c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.293,20.176H24.22v2.917H23.108V16.479H24.22v2.8h1.073v-2.8h1.122v6.614H25.293Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.377,16.479v5c0,1.025-.439,1.688-1.57,1.688a1.493,1.493,0,0,1-1.659-1.688v-5H28.26v5.112c0,.39.156.653.547.653s.546-.263.546-.653V16.479Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.047,18.937v4.156H31.11V16.479H32.2l1.2,3.794V16.479h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.74,19.562h1.581v3.531h-.8v-.721a1,1,0,0,1-1.064.8c-.956,0-1.4-.76-1.4-1.785v-3.2A1.567,1.567,0,0,1,36.73,16.4c1.23,0,1.591.683,1.591,1.659v.585H37.306v-.673c0-.41-.156-.644-.556-.644s-.576.283-.576.683v3.551c0,.4.166.683.547.683.36,0,.546-.2.546-.634V20.44H36.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.053,16.479h2.654v.907H40.165v1.893h1.1v.9h-1.1v2.01h1.542v.907H39.053Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.512,17.386v2.058h.37a.481.481,0,0,0,.547-.546v-.975c0-.361-.165-.537-.547-.537Zm0,2.673v3.034H42.4V16.479h1.62c1.121,0,1.531.556,1.531,1.483v.848c0,.713-.252,1.132-.888,1.278l1.064,3.005h-1.17Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG02);
export default __webpack_public_path__ + "static/media/G02.29010dda8205f0eeb35c2826f6c07ede.svg";
export { ForwardRef as ReactComponent };